import React, { useState } from "react";
import "./Estimate_Time_Component.css";
import OrderTrackModal from "../../Common_modal/order_track_modal/OrderTrackModal";

const Estimate_Time_Component = () => {
  const [showCouponModal, setShowCouponModal] = useState(false);

  return (
    <div className="product_detail_head">
      <div className="content_holder">
        <div className="left_part">
          <div className="img_holder">
            <img
              src={process.env.PUBLIC_URL + "/assets/Image/my_order/time.png"}
            />
          </div>
          <div className="">
            <p className="product_name">
              Estimated Time of Delivery : 12 minutes
            </p>
          </div>
        </div>

        <div className="order_id_div">
          <p
            onClick={() => {
              setShowCouponModal(true);
            }}
          >
            Track Order
          </p>
        </div>
      </div>

      <OrderTrackModal
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
      />
    </div>
  );
};

export default Estimate_Time_Component;
